import { useQuery } from "@tanstack/react-query";
import { getProject } from "../api/projects";
import type { Project, Status } from "../types";

export const RUNNING_STATUSES: ReadonlySet<Status> = new Set<Status>([
  "searching",
  "extracting",
  "translating",
  "building",
]);

export function useProject(id: string | undefined) {
  return useQuery<Project>({
    queryKey: ["project", id],
    queryFn: () => getProject(id!),
    enabled: !!id,
    refetchInterval: (q) =>
      RUNNING_STATUSES.has(q.state.data?.status as Status) ? 2000 : false,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
}
